/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbAnneeScolaireDto } from './FcbAnneeScolaireDto';
import {
    FcbAnneeScolaireDtoFromJSON,
    FcbAnneeScolaireDtoFromJSONTyped,
    FcbAnneeScolaireDtoToJSON,
} from './FcbAnneeScolaireDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbAnneeScolaireDtoPaginatedResults
 */
export interface FcbAnneeScolaireDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbAnneeScolaireDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbAnneeScolaireDto>}
     * @memberof FcbAnneeScolaireDtoPaginatedResults
     */
    results?: Array<FcbAnneeScolaireDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbAnneeScolaireDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbAnneeScolaireDtoPaginatedResults interface.
 */
export function instanceOfFcbAnneeScolaireDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAnneeScolaireDtoPaginatedResultsFromJSON(json: any): FcbAnneeScolaireDtoPaginatedResults {
    return FcbAnneeScolaireDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbAnneeScolaireDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAnneeScolaireDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbAnneeScolaireDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbAnneeScolaireDtoPaginatedResultsToJSON(value?: FcbAnneeScolaireDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbAnneeScolaireDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

